<script setup>
import axios from "axios";
import Notification from "./Notification.vue"

import { ref, watch } from 'vue'

const props = defineProps({ notifications: Array})

const notifications = ref(props.notifications)

const showReadAll = ref(props.notifications.length > 0)

function add(object) {
    notifications.value.push(object)
    showReadAll.value = true;
}

defineExpose({ add })

const notificationObjects = ref([])

function readAll() {
    axios.post('/portal/notificaties/readAll').then(response => {
        notificationObjects.value.forEach(notificationObject => {
            notificationObject.show = false
            showReadAll.value = false
        })
    })
}

function setReadAll() {
    //check notifications if all are read
    let allRead = true;
    notificationObjects.value.forEach(notificationObject => {
        console.log(notificationObject.show);
        if (notificationObject.show) {
            allRead = false
        }
    })

    showReadAll.value = !allRead;
}

</script>

<template>
    <div id="notifications">
        <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50">
            <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
                <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                    <div v-if="showReadAll" class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <font-awesome-icon :icon="['far', 'inbox']" class="text-gray-400 h-5 w-5 shrink-0"/>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm font-medium text-gray-900">Alles accepteren</p>
                                    <p class="mt-1 text-sm text-gray-500"><button type="button" class="" @click="readAll">Alles gelezen</button></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <Notification :notification="notification" v-for="notification in notifications" ref="notificationObjects" :showCallback="setReadAll"/>
            </div>
        </div>
    </div>
</template>